import api from './axios';

// Tables
export const getTables = async () => {
  const response = await api.get('/tables');
  return response.data;
};

export const getTable = async (tableId) => {
  const response = await api.get(`/tables/${tableId}`);
  return response.data;
};

export const getTableByQR = async (qrCode) => {
  const response = await api.get(`/tables/qr/${qrCode}`);
  return response.data;
};

export const createTable = async (tableData) => {
  const response = await api.post('/tables', tableData);
  return response.data;
};

export const updateTable = async (tableId, tableData) => {
  const response = await api.put(`/tables/${tableId}`, tableData);
  return response.data;
};

export const deleteTable = async (tableId) => {
  const response = await api.delete(`/tables/${tableId}`);
  return response.data;
};

export const getTableQRImage = (tableId) => {
  const BACKEND_URL = window.location.origin;
  return `${BACKEND_URL}/api/tables/${tableId}/qr-image`;
};

// Orders
export const getOrders = async (statusFilter = null) => {
  const url = statusFilter ? `/orders?status_filter=${statusFilter}` : '/orders';
  const response = await api.get(url);
  return response.data;
};

export const getActiveOrders = async () => {
  const response = await api.get('/orders/active');
  return response.data;
};

export const getTableOrders = async (tableNumber) => {
  const response = await api.get(`/orders/table/${tableNumber}`);
  return response.data;
};

export const getOrder = async (orderId) => {
  const response = await api.get(`/orders/${orderId}`);
  return response.data;
};

export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData);
  return response.data;
};

export const updateOrder = async (orderId, orderData) => {
  const response = await api.put(`/orders/${orderId}`, orderData);
  return response.data;
};

export const deleteOrder = async (orderId) => {
  const response = await api.delete(`/orders/${orderId}`);
  return response.data;
};

export const printOrder = async (orderId) => {
  const response = await api.get(`/orders/${orderId}/print`);
  return response.data;
};

export const getTableBill = async (tableNumber) => {
  const response = await api.get(`/orders/table/${tableNumber}/bill`);
  return response.data;
};